/**
 * On charge les composants uniquement lorsqu'on a récupéré la session provenant du server
 */
const loadSessionOnceFromServer = (session) => {
  const global = document.getElementById("react--global-needs-session");
  if (global !== null) {
    import(/* webpackChunkName: "global-needs-session" */ "feature/global-needs-session/index").then((index) => {
      index.default(global, session);
    });
  }

  const travelInformation = document.getElementById("react--travel-information");
  if (travelInformation !== null) {
    import(/* webpackChunkName: "travel-information" */ "feature/travel-information/index").then((index) => {
      index.default(travelInformation, session);
    });
  }

  const userCredits = document.getElementById("react--user-credits");
  if (userCredits !== null) {
    import(/* webpackChunkName: "user-credits" */ "feature/user-credits/index").then((index) => {
      index.default(userCredits, session);
    });
  }

  const giftCards = document.getElementById("react--gift-cards");
  if (giftCards !== null) {
    import(/* webpackChunkName: "gift-cards" */ "feature/gift-cards/index").then((index) => {
      index.default(giftCards, session);
    });
  }

  const review = document.getElementById("react--review");
  if (review !== null) {
    import(/* webpackChunkName: "review" */ "feature/review/index").then((index) => {
      index.default(review, session);
    });
  }
};

export { loadSessionOnceFromServer };
